import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconEnvironmentSensor } from 'svgIcons/MotionPortalIcons';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import { DisconnectEnvironmentSensor } from './DisconnectEnvironmentSensor';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import useUserCapability from 'sharedHooks/useUserCapability';

const EnvironmentSensorsRowComponent = ({ gatewayConnectedEnvironmentSensorData, gatewayID }) => {
    const { t: translate } = useTranslation();
    const userCapability = useUserCapability();
    const hasGatewayAdminViewCapability = userCapability?.hasGatewayAdminViewCapability?.() === true;
    const hasGatewayAdminReadViewCapability = userCapability?.hasGatewayAdminReadView?.() === true;
    const isGatewayReadOnlyMode = hasGatewayAdminReadViewCapability && !hasGatewayAdminViewCapability;
    const [isShowDisconnectEnvironmentSensorDialog, setIsShowDisconnectEnvironmentSensorDialog] = useState(false);
    if (isEmpty(gatewayConnectedEnvironmentSensorData)) {
        return <div className='empty-environment-sensor-list'>{translate('ABB.Powertrain.Frontend.emptyEnvironmentSensorsAssets')}</div>;
    }
    return <div className='environment-sensor-list__row'>
        <div className='environment-sensor-list__cell' id='environment-sensor__serialnumber'>
            <div className='environment-name'>
                <div className='environment-name__wrap'>
                    <IconEnvironmentSensor />
                    <span className='environment-name__slno'>{gatewayConnectedEnvironmentSensorData?.serialNumber || '-'}</span>
                </div>
            </div>
        </div>
        <div className='environment-sensor-list__cell' id='environment-sensor__last-signal-received'>
            {gatewayConnectedEnvironmentSensorData?.lastSignalReceivedTimeStamp ? formatDateTime(gatewayConnectedEnvironmentSensorData?.lastSignalReceivedTimeStamp) : '-'}
        </div>
        {!isGatewayReadOnlyMode &&
            <div className='environment-sensor-list__cell environment-sensor-list__cell--disconnect-sensor' id='environment-sensor__disconnect-sensor'>
                <GeneralButton
                    type='discreet'
                    className='environment-sensor-list__disconnect'
                    text={translate('ABB.Powertrain.Frontend.DisconnectLabel')}
                    onClick={() => setIsShowDisconnectEnvironmentSensorDialog(true)}>
                </GeneralButton>
            </div>}
        {
            !isGatewayReadOnlyMode && isShowDisconnectEnvironmentSensorDialog &&
            <DisconnectEnvironmentSensor
                isShowDisconnectEnvironmentSensorDialog={isShowDisconnectEnvironmentSensorDialog}
                setIsShowDisconnectEnvironmentSensorDialog={setIsShowDisconnectEnvironmentSensorDialog}
                gatewayID={gatewayID}
            />
        }
    </div>;
};

EnvironmentSensorsRowComponent.propTypes = {
    gatewayConnectedEnvironmentSensorData: PropTypes.object,
    gatewayID: PropTypes.number
};

export default EnvironmentSensorsRowComponent;
